import { Component, ViewEncapsulation } from '@angular/core';

/**
 * Account Component, serves as a page wrapper for /account routes
 */
@Component({
  selector: 'widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WidgetComponent {
  /**
   * @constructor
   */
  constructor() {}
}
